import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { HeroLayout } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`Primer's interface guidelines are a collection of principles, standards, and usage guidelines for designing GitHub
interfaces.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides"
      }}>{`Guides`}</a></h4>
    <p>{`Standards, guidelines, and tools to getting started with Primer.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/foundations"
      }}>{`Foundations`}</a></h4>
    <p>{`The fundamental parts of the design system that underpin all GitHub interfaces, such as color and typography.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/ui-patterns"
      }}>{`UI patterns`}</a></h4>
    <p>{`Design guidelines covering common user workflows.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/components"
      }}>{`Components`}</a></h4>
    <p>{`Design and usage guidelines for individual Primer components.`}</p>
    <h2>{`Need help?`}</h2>
    <p>{`If you found a bug on this website, please `}<a parentName="p" {...{
        "href": "https://github.com/primer/issues/new"
      }}>{`open a new issue`}</a>{` with as much detail as possible, including steps to replicate the bug, screenshots, links, and expected results.`}</p>
    <p>{`If you need help using and designing with Primer, and you are GitHub staff, please visit the #primer Slack channel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      